// AUTO-GENERATED -- do not edit manually.
// Re-generate by running: npm run fsx-types:local  (or fsx-types:dev)
// Coverage gaps (type-link targets with no constraint entry -- fallback to global search):
//   ClerkReviewFiling.additionalDataCaseValues -> 'ClerkReviewAdditionalDataValue'
//   ClerkReviewFiling.validationErrors -> 'Error'
//   ClerkReviewDocument.availableDocumentJudgeReviewers -> 'CaseJudge'
//   ClerkReviewDocument.additionalDataValues -> 'ClerkReviewAdditionalDataValue'
//   FilingDraft.validationErrors -> 'Error'
//   JudgeReviewFiling.validationErrors -> 'Error'
//   JudgeReviewCase.additionalJudges -> 'JudgeReviewCaseJudge'
//   JudgeReviewAction.documents -> 'JudgeReviewActionDocument'
//   Add a [PatchDisabled] annotation on the target model to close these gaps.


export type PatchDisabledScope = 'scalar' | 'collection-membership' | 'subtree';

/** Maps model name -> property name -> patch-disabled scope. */
export const PATCH_CONSTRAINTS = {
  "PersonName": {
    "fullName": "scalar",
    "suppressed": "scalar",
    "display": "scalar",
  },
  "ClerkReviewFiling": {
    "filingUniqueId": "scalar",
    "filingId": "scalar",
    "courtId": "scalar",
    "courtName": "scalar",
    "isOpf": "scalar",
    "filingComment": "scalar",
    "reviewerName": "subtree",
    "filerNote": "scalar",
    "filerName": "subtree",
    "filerOrganizationName": "scalar",
    "authorizerName": "subtree",
    "authorizerOrganizationName": "scalar",
    "isJudgeReviewFilingInProcess": "scalar",
    "feeWaiverReason": "scalar",
    "payment": "subtree",
    "clerkReviewCases": "collection-membership",
    "clerkReviewDocuments": "collection-membership",
    "additionalDataCaseValues": "collection-membership",
    "validationErrors": "collection-membership",
  },
  "ClerkReviewCase": {
    "caseId": "scalar",
    "caseClassId": "scalar",
    "caseClass": "scalar",
    "caseType": "scalar",
    "division": "scalar",
    "sendingParties": "collection-membership",
    "queueCaseParticipants": "collection-membership",
    "caseParticipants": "collection-membership",
    "totalServiceRecipients": "scalar",
  },
  "ClerkReviewCaseJudge": {
    "judgeName": "subtree",
  },
  "ClerkReviewCaseParticipant": {
    "entryId": "scalar",
    "caseParticipantId": "scalar",
    "isConfidential": "scalar",
  },
  "ClerkReviewParty": {
    "partyId": "scalar",
    "jcmsPartyId": "scalar",
    "partyType": "scalar",
    "partySubType": "scalar",
    "partyStatus": "scalar",
  },
  "ClerkReviewPartyAlias": {
    "partyId": "scalar",
    "aliasType": "scalar",
    "partyStatus": "scalar",
  },
  "ClerkReviewAttorney": {
    "userId": "scalar",
    "attorneyName": "subtree",
    "attorneyType": "scalar",
    "counselType": "scalar",
    "attorneyStatus": "scalar",
    "attorneyBarNumber": "scalar",
    "firm": "scalar",
  },
  "ClerkReviewDocument": {
    "documentId": "scalar",
    "pages": "scalar",
    "filingType": "scalar",
    "reviewStatus": "scalar",
    "accessType": "scalar",
    "judicialAction": "scalar",
    "redactedDocumentId": "scalar",
    "clerkReviewDocumentFees": "collection-membership",
    "sendToJudge": "subtree",
    "customFields": "collection-membership",
    "showRedactDocumentLink": "scalar",
    "availableReviewStatuses": "collection-membership",
    "allowClerkToAssignJudge": "scalar",
    "availableDocumentJudgeReviewers": "collection-membership",
    "aiReview": "subtree",
    "additionalDataValues": "collection-membership",
  },
  "ClerkReviewDocumentFee": {
    "feeTypeId": "scalar",
    "feeType": "scalar",
    "adjustable": "scalar",
  },
  "ClerkReviewCustomField": {
    "label": "scalar",
    "caption": "scalar",
    "type": "scalar",
    "length": "scalar",
  },
  "ClerkReviewDocumentReviewStatus": {
    "reviewStatusId": "scalar",
    "reviewStatus": "scalar",
  },
  "FilingDraft": {
    "filingId": "scalar",
    "filingModeId": "scalar",
    "courtId": "scalar",
    "courtStateCode": "scalar",
    "courtName": "scalar",
    "caseClassId": "scalar",
    "hasBeenSubmitted": "scalar",
    "caseClassName": "scalar",
    "caseTypeId": "scalar",
    "caseTypeName": "scalar",
    "dateCreated": "scalar",
    "divisionName": "scalar",
    "filerUserDetails": "subtree",
    "authorizerUserDetails": "subtree",
    "feeWaiverReasonComment": "scalar",
    "validationErrors": "collection-membership",
  },
  "FilingDraftUserDetails": {
    "userId": "scalar",
    "organizationId": "scalar",
    "name": "subtree",
    "organizationName": "scalar",
    "phone": "scalar",
    "email": "scalar",
  },
  "FilingDraftCase": {
    "caseNumber": "scalar",
    "caseTypeId": "scalar",
    "caseTypeName": "scalar",
  },
  "FilingDraftDocument": {
    "filingTypeName": "scalar",
    "accessTypeName": "scalar",
    "filingCategoryName": "scalar",
    "isReady": "scalar",
    "documentByteCount": "scalar",
    "documentPageCount": "scalar",
    "documentStatutoryFee": "scalar",
  },
  "FilingDraftPartyAlias": {
    "aliasTypeName": "scalar",
  },
  "FilingDraftAttorney": {
    "name": "subtree",
    "organizationId": "scalar",
    "organizationName": "scalar",
    "serviceMethodId": "scalar",
    "serviceMethodName": "scalar",
  },
  "FilingDraftAttorneyToPartyMapping": {
    "attorneyTypeName": "scalar",
    "counselTypeName": "scalar",
    "partyTypeName": "scalar",
    "partySubTypeName": "scalar",
    "partyStatus": "scalar",
  },
  "JudgeReviewFiling": {
    "reviewedFilingUniqueId": "scalar",
    "reviewedFilingId": "scalar",
    "inProcess": "scalar",
    "isOpf": "scalar",
    "courtId": "scalar",
    "courtName": "scalar",
    "judgeReviewerName": "subtree",
    "judgeReviewCases": "collection-membership",
    "judgeReviewDocuments": "collection-membership",
    "currentAction": "subtree",
    "submittedActions": "collection-membership",
    "validationErrors": "collection-membership",
  },
  "JudgeReviewCase": {
    "caseId": "scalar",
    "caseNumber": "scalar",
    "caseName": "scalar",
    "caseClassId": "scalar",
    "caseClass": "scalar",
    "caseTypeId": "scalar",
    "caseType": "scalar",
    "divisionId": "scalar",
    "division": "scalar",
    "primaryJudge": "subtree",
    "alternateJudge": "subtree",
    "additionalJudges": "collection-membership",
  },
  "JudgeReviewDocument": {
    "existingDocumentId": "scalar",
    "status": "scalar",
    "judgeReviewFilingType": "scalar",
    "judgeReviewDocumentStoreId": "scalar",
    "documentUploadUri": "scalar",
    "accessType": "scalar",
    "isReady": "scalar",
    "documentByteCount": "scalar",
    "documentPageCount": "scalar",
    "docStoreError": "scalar",
    "isFinalReady": "scalar",
    "blankPagesAdded": "scalar",
    "isReviewed": "scalar",
  },
  "JudgeReviewAction": {
    "collectionId": "scalar",
    "spawnedFilingId": "scalar",
    "documents": "collection-membership",
    "actedByUserId": "scalar",
    "actedDate": "scalar",
  },
} as const satisfies Record<string, Record<string, PatchDisabledScope>>;

/** Derived from PATCH_CONSTRAINTS -- narrows to the literal union of model names. */
export type PatchModelType = keyof typeof PATCH_CONSTRAINTS;

/** Maps model name -> collection property name -> element model type name.
 *  Used by patch-validator to recurse with the correct type context. */
export const PATCH_TYPE_LINKS = {
  "ClerkReviewFiling": {
    "clerkReviewCases": "ClerkReviewCase",
    "clerkReviewDocuments": "ClerkReviewDocument",
    "additionalDataCaseValues": "ClerkReviewAdditionalDataValue",
    "validationErrors": "Error",
  },
  "ClerkReviewCase": {
    "sendingParties": "ClerkReviewCaseParticipant",
    "queueCaseParticipants": "ClerkReviewCaseParticipant",
    "caseParticipants": "ClerkReviewCaseParticipant",
  },
  "ClerkReviewDocument": {
    "clerkReviewDocumentFees": "ClerkReviewDocumentFee",
    "customFields": "ClerkReviewCustomField",
    "availableReviewStatuses": "ClerkReviewDocumentReviewStatus",
    "availableDocumentJudgeReviewers": "CaseJudge",
    "additionalDataValues": "ClerkReviewAdditionalDataValue",
  },
  "FilingDraft": {
    "validationErrors": "Error",
  },
  "JudgeReviewFiling": {
    "judgeReviewCases": "JudgeReviewCase",
    "judgeReviewDocuments": "JudgeReviewDocument",
    "submittedActions": "JudgeReviewAction",
    "validationErrors": "Error",
  },
  "JudgeReviewCase": {
    "additionalJudges": "JudgeReviewCaseJudge",
  },
  "JudgeReviewAction": {
    "documents": "JudgeReviewActionDocument",
  },
} as const satisfies Record<string, Record<string, string>>;

/** Maps model name -> non-readonly property name -> plain-object type name.
 *  Used by patch-validator to recurse into sub-object constraints.
 *  Populated automatically once [PatchDisabled] fields exist on the target type. */
export const PATCH_OBJECT_LINKS = {
  "CaseJudge": {
    "name": "PersonName",
  },
  "ActiveCaseAttorney": {
    "name": "PersonName",
  },
  "ActiveCaseParty": {
    "name": "PersonName",
  },
  "ClerkReviewJudge": {
    "judgeName": "PersonName",
  },
  "ReviewFilingSummary": {
    "authorizerName": "PersonName",
    "reviewerName": "PersonName",
  },
  "ClerkReviewCase": {
    "primaryJudge": "ClerkReviewCaseJudge",
    "alternateJudge": "ClerkReviewCaseJudge",
  },
  "ClerkReviewCaseParticipant": {
    "party": "ClerkReviewParty",
    "attorney": "ClerkReviewAttorney",
  },
  "ClerkReviewParty": {
    "partyName": "PersonName",
  },
  "ClerkReviewPartyAlias": {
    "partyName": "PersonName",
  },
  "ClerkReviewFilingConfiguration": {
    "lockedByName": "PersonName",
  },
  "ClerkReviewFilingEscalation": {
    "escalatedBy": "PersonName",
  },
  "DashboardAttorney": {
    "name": "PersonName",
  },
  "FilingDraftParty": {
    "partyName": "PersonName",
  },
  "FilingDraftPartyAlias": {
    "name": "PersonName",
  },
  "FilingDraftAdditionalRecipient": {
    "name": "PersonName",
  },
  "FilingDraftCourtesyCopy": {
    "name": "PersonName",
  },
  "CourtesyCopyJudges": {
    "name": "PersonName",
  },
  "FilingUserAdditionalRecipient": {
    "name": "PersonName",
  },
  "JudgeChamberSummary": {
    "judgeName": "PersonName",
  },
  "JudgeChamberMember": {
    "name": "PersonName",
  },
  "JudgeChamberNote": {
    "authorName": "PersonName",
  },
  "JudgeChamberMentionCandidate": {
    "name": "PersonName",
  },
  "AvailableJudgeUser": {
    "name": "PersonName",
  },
  "JudgeReviewFilingSummary": {
    "authorizerName": "PersonName",
  },
  "JudgeReviewCaseJudge": {
    "name": "PersonName",
  },
  "JudgeReviewFilingAdditionalRecipient": {
    "name": "PersonName",
  },
  "JudgeReviewSubmitResponse": {
    "action": "JudgeReviewAction",
  },
  "JudgeReviewFilingConfiguration": {
    "filerName": "PersonName",
    "filingAuthorizerName": "PersonName",
  },
  "JudgeReviewSendingParticipant": {
    "party": "PersonName",
    "attorney": "PersonName",
  },
  "JudgeReviewCourtesyCopyRecipient": {
    "judgeName": "PersonName",
  },
} as const satisfies Record<string, Record<string, string>>;

/** Maps model name -> freely-patchable array property name -> element model type name.
 *  Used by patch-validator to recurse into element-type constraints for sub-property
 *  paths on collections that are themselves patchable (add/remove of elements is allowed).
 *  Populated automatically once [PatchDisabled] fields exist on the element type. */
export const PATCH_ARRAY_LINKS = {
  "ClerkReviewCase": {
    "multipleJudges": "ClerkReviewCaseJudge",
  },
  "ClerkReviewParty": {
    "clerkReviewPartyAliases": "ClerkReviewPartyAlias",
  },
  "FilingDraft": {
    "cases": "FilingDraftCase",
    "documents": "FilingDraftDocument",
    "attorneys": "FilingDraftAttorney",
    "attorneyToPartyMappings": "FilingDraftAttorneyToPartyMapping",
  },
  "FilingDraftParty": {
    "partyAliases": "FilingDraftPartyAlias",
  },
  "FilingDraftCaseParticipants": {
    "attorneys": "FilingDraftAttorney",
    "attorneyToPartyMappings": "FilingDraftAttorneyToPartyMapping",
  },
} as const satisfies Record<string, Record<string, string>>;
